import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { CloudRoutePage } from "../app/cloudRoute";

export const Route = createFileRoute("/cloud")({
  component: CloudRoute,
});

function CloudRoute(): JSX.Element {
  const search = Route.useSearch();
  return <CloudRoutePage search={search} />;
}
